// Hues here are limited to the design-system set that `src/index.css` inverts
// under `.dark` (see the note in admin/types/constants/diagnostics.ts), so these
// stay legible on the nextgen dark theme without `dark:` variants.

/** Text color for a rubric score. `null` (not-applicable) renders muted. */
export function scoreColor(score: number | null): string {
  if (score == null) return "text-muted-foreground";
  if (score >= 4) return "text-green-600";
  if (score >= 3) return "text-orange-600";
  return "text-red-600";
}

/** Bar/background color for a rubric score. `null` (not-applicable) renders neutral. */
export function scoreBg(score: number | null): string {
  if (score == null) return "bg-muted-foreground/30";
  if (score >= 4) return "bg-green-500";
  if (score >= 3) return "bg-orange-500";
  return "bg-red-500";
}
